// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"c60fc30b","142":"f29d63ec","376":"505d5ce3","427":"39041bf5"}[chunkId] + ".css";
};